import RestResource from '../rest.service';
import Service from '../api.service';

export default class SellersService extends RestResource {
  map(payload) {
    return {
      name: payload.name,
      city_id: payload.city,
      address: payload.address,
      email: payload.email,
      phone: payload.phone,
      commission: payload.commission,
    };
  }

  search(params) {
    return Service.get(`${this.getResource()}/search`, { params }).catch(this.handleErrors);
  }

  constructor() {
    super('sellers');
  }
}
